<!--根据单个推荐来渲染图片 view:10-->
<template>
    <div class="view6Wrapper">
        <BaseCard :name="list[0].title" :img-url="list[0].imgUrl"
                  @on-click="()=>onRouter(list[0].linkUrl,list[0].id,list[0].type, list[0].title)" v-if="list[0].imgUrl"
                  color="#4D5772"/>
    </div>
</template>


<script>
    import {mapState, mapActions, mapMutations} from "vuex";
    import BaseCard from "../Use/base-card";
    import CrossSlip from "../Use/cross-slip-wrapper";

    export default {
        name: "View6",
        components: {BaseCard, CrossSlip},
        props: {
            list: {
                type: Array,
                default: []
            },
            tips: {
                type: String,
                default: ""
            }
        },
        data() {
            return {};

        },
        methods: {

            onRouter(path, id, type, title) {
                this.$emit("on-router", path, id, false, type, title);
            },
            onSwitch(value, tips) {
                this.setToastShow(true);
                this.setToastContent({toastType: 0, list: {name: "", content: tips}});
            }
        }
    };
</script>
<style lang="less" scoped>
    @import "../../assets/less/common";

    .view6Wrapper {
        margin-left: .5rem;
    }

</style>
